/* eslint-disable */
// import { validation } from './commonValidation';
import toast from './toast';

const editConditions = () => {
  const editForm = document.querySelector('.js-edit-conditions-form');

  const sendEditForm = e => {
    let checkedConditions = document.querySelectorAll(
      '.js-condition input[type="checkbox"]:checked',
    );

    let ajaxData = {
      action: 'ks_edit_conditions',
      ks_register_conditions_checked: [],
    };
    checkedConditions.forEach(condition => {
      ajaxData.ks_register_conditions_checked.push(condition.value);
    });
    ajaxData.ks_register_conditions_checked = JSON.stringify(
      ajaxData.ks_register_conditions_checked,
    );

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');
    e.preventDefault();
    const ajax_url = document.querySelector('meta[name="adjx"]').content;
    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);
    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );
    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        const body = document.querySelector('body');
        const response = JSON.parse(request.response);
        const toastWrapper = document.createElement('div');

        toastWrapper.innerHTML = response.message;
        body.append(toastWrapper);
        if (response.success) {
          if (response.success && response.redirect) {
            setTimeout(() => {
              window.location.href = response.redirect;
            }, 3000);
          }
        }
        toast();
        body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
      }
    };
    request.onerror = function() {};
    request.send(ajaxParameters);
  };
  if (editForm) {
    editForm.addEventListener('submit', sendEditForm);
  }
};

export default editConditions;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/editConditions.js